import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ShoppingMallRequest, ShoppingMallRequestSearch } from '../../../models/api-store/shopping-mall/shopping-mall.request.model';
import { ShoppingMallResponse, ShoppingMallResponseSearch } from '../../../models/api-store/shopping-mall/shopping-mall.response.model';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ShoppingMallService {

  constructor(private http: HttpClient) { }
  pathUrl: string = environment.backend.pathUrl.store.custompage_shoppingmall;
  baseUrl: string = environment.backend.baseUrl_backend;
  url: string = this.baseUrl + this.pathUrl;


  create(request: ShoppingMallRequest): Observable<ShoppingMallResponse> {
    let url = this.url + "/";
    return this.http.post<ShoppingMallResponse>(url, request);
  }

  getEntity(id: number): Observable<ShoppingMallResponse> {
    let url = this.url + "/" + id;
    return this.http.get<ShoppingMallResponse>(url);
  }

  update(id: number, request: ShoppingMallRequest): Observable<ShoppingMallResponse> {
    let url = this.url + "/" + id;
    return this.http.put<ShoppingMallResponse>(url, request);
  }

  delete(id: number) {
    let url = this.url + "/" + id;
    return this.http.delete<any>(url);
  }

  search(request:ShoppingMallRequestSearch):Observable<ShoppingMallResponseSearch>{
    let url = this.url+"/search";
    return this.http.post<ShoppingMallResponseSearch>(url,request);
  }

  findAll():Observable<any>{
    let url = this.url;
    return this.http.get<any[]>(url);
  }
}
